// extracted by mini-css-extract-plugin
export var card = "_lk-0";
export var content = "_lk-2";
export var details = "_lk-3";
export var icon = "_lk-1";
export var iconBlue = "_lk-5";
export var iconBrand = "_lk-4";
export var iconGrayBlue = "_lk-6";
export var iconGreen = "_lk-7";
export var iconIndigo = "_lk-8";
export var iconOrange = "_lk-9";
export var iconPurple = "_lk-a";
export var iconRed = "_lk-b";
export var iconWarning = "_lk-c";